import "./chunk--chunk-RQ7252KT.js";

// src/js/components/BackToTop.js
var BackToTop = class {
  constructor(el) {
    el.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }
};
var BackToTop_default = BackToTop;
export {
  BackToTop_default as default
};
